module.exports = __webpack_public_path__ + "static/img/snapbot-btn.715658e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/snapbot-btn.png
// module id = FjjU
// module chunks = 1